import { useUserRoleContext } from '@/contexts/UserRoleContext';
export type { UserRole, UserRoleContextValue as UseUserRoleResult } from '@/contexts/UserRoleContext';

export function useUserRole() {
  return useUserRoleContext();
}
